<template>
  <div>
    <!--스와이퍼 내 인라인 스타일은 html용 임의스타일로 개발시 제거요망-->
    <swiper
      v-if="popupList.length > 0"
      class="swiper-container"
      :modules="modules"
      :pagination="{
        clickable: true,
        el: '.swiper-pagination'
      }"
      :autoplay="{
        delay: 3000,
        disableOnInteraction: false
      }"
    >
      <swiper-slide v-for="(item, index) in popupList" :key="index">
        <div class="img-con">
          <img :src="ConstCode.getImagePath(item.storedFileName, 'origin')" @click="fnClick(item)" />
        </div>
      </swiper-slide>
      <div class="swiper-pagination"></div>
    </swiper>
  </div>
</template>

<script setup>
/** swiper **/
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper';
import { defineProps, ref } from 'vue';
import { useStore } from 'vuex';
const modules = ref([Navigation, Pagination, Scrollbar, A11y, Autoplay]);
// swiper/css/ 친구들 필수
import 'swiper/css';
import 'swiper/css/pagination';

import Util from '@/common/utils/Util';
import ConstCode from '@/common/constants/ConstCode';
import router from '@/router';
const { nativeLink } = Util;
const store = useStore();

const props = defineProps({
  popupList: Array
});
const list = ref(props.popupList);

// const dynamicLinkPath = computed(() => store.getters['user/getDynamicLinkPath']),
// const pushFullPath = computed(() => store.getters['user/getPushFullPath']),

// :pagination="{clickable: true}" 클릭 시
const fnClick = item => {
  // window.location.href = popupUrl
  if (item.moveType === ConstCode.MoveType.MOVE.value) {
    router.push({ path: item.linkUrl });
  } else {
    nativeLink(item.linkUrl);
  }
};
</script>
